import React from 'react';
import { connect } from 'react-redux';
import dynamic from 'next/dynamic';
import {
  playerActions,
  trackActions,
  RootState,
  Dispatch,
  SwiperFilter,
} from '../../api';

import { CenterLoader } from '../../components/common/Miscellanea';
import {
  StateProps,
  DispatchProps,
  OwnProps,
} from '../../components/Swiper/Swiper';

const Swiper = dynamic(import('../../components/Swiper'), {
  ssr: false,
  loading: () => <CenterLoader />,
});

export default connect<StateProps, DispatchProps, OwnProps, RootState>(
  ({
    player: { currentPlaylist, currentTrack },
    tracks: { entries },
    authentication: { hasCheckedInitialLogin, isLoggedIn },
    user: { requesting },
  }) => {
    const currentId =
      currentTrack !== undefined ? currentPlaylist[currentTrack] : undefined;

    const playingTrack = currentId ? entries[currentId] : undefined;

    return {
      authenticated: hasCheckedInitialLogin && isLoggedIn,
      currentTrackIndex: currentTrack || 0,
      requesting,
      playingTrack,
    };
  },
  (dispatch: Dispatch) => ({
    onPlayerSkip: () => dispatch(playerActions.skipCurrentTrack()),
    onSkip: (id: number) => dispatch(trackActions.reportTrackSkip(id)),
    onLike: (id: number) => dispatch(trackActions.likeTrack(id)),
    fetchTracks: (filters: SwiperFilter) =>
      dispatch(trackActions.fetchTracksFilteredRandom(filters)),
  }),
)(Swiper);
